export default __webpack_public_path__ + "static/media/PPI-driveway-011.ddeca8b8.jpg";